import { AVAILABLE_LANGS } from "@typings/globals";

export const langFromTag = (lang: string): AVAILABLE_LANGS =>
  lang.split("-")[0] as AVAILABLE_LANGS;
